import { Host, h } from "@stencil/core";
import { hasShadowDom, injectFont, parseAndGetAriaAttributes, } from "../../utils";
export class DcUiButton {
    constructor() {
        /** Adds a size to the button. Default value is 'normal'.*/
        this.size = 'normal';
        /** Adds a type to the button. Default value is 'submit'. */
        this.type = 'submit';
        /** Adds a variant to the button. Default value is 'secondary'. */
        this.variant = 'secondary';
        /** Hides the label on the button. Default value is false. */
        this.hideLabel = false;
        /** Disables the button on the interface. Default value is false. */
        this.disabled = false;
        /**
         * Hack to make the button behave has expected when inside forms.
         * @see https://github.com/ionic-team/ionic-framework/blob/master/core/src/components/button/button.tsx#L155-L175
         */
        this.handleClick = (ev) => {
            if (hasShadowDom(this.host)) {
                const parentForm = this.host.closest('form');
                if (parentForm) {
                    ev.preventDefault();
                    const fakeButton = document.createElement('button');
                    if (this.type) {
                        fakeButton.type = this.type;
                    }
                    fakeButton.style.display = 'none';
                    parentForm.appendChild(fakeButton);
                    fakeButton.click();
                    fakeButton.remove();
                }
            }
        };
    }
    componentWillLoad() {
        injectFont();
    }
    async focusElement() {
        this.button.focus();
    }
    render() {
        return (h(Host, { key: '38ec5f89705aeb26ab04cf48fa7ffe052d1d384c', onClick: (e) => {
                if (this.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            } }, h("button", Object.assign({ key: '8bc0ba3bed60ad0802ac2ab7c6e2910d30b05139', class: `
            dc-ui-btn
            dc-ui-btn--${this.size}
            dc-ui-btn--${this.variant}
            ${this.hideLabel && this.icon ? 'dc-ui-btn--hide-label' : ''}
            ${this.disabled ? 'dc-ui-btn--disabled' : ''}
            ${this.align ? `dc-ui-btn--align-${this.align}` : ''}
            ${this.icon ? 'dc-ui-btn--icon' : ''}
          `, type: this.type, disabled: this.disabled, "aria-disabled": this.disabled ? 'true' : null }, parseAndGetAriaAttributes(this.aria), { name: this.name, ref: (button) => (this.button = button), onClick: this.handleClick }), this.icon || this.iconSource ? (h("dc-ui-icon", { "aria-hidden": "true", name: this.icon, source: this.iconSource, size: this.size === 'normal' ? 'medium' : this.size })) : null, h("span", { key: 'b8fdd4d2aab80fcd80959dd65810b4cd7f2eaffd' }, h("slot", { key: 'cadd0ba8a4e20f155d31cdafb2e1db9971739043' })))));
    }
    static get is() { return "dc-ui-button"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-button.css"]
        };
    }
    static get properties() {
        return {
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TButtonSize",
                    "resolved": "\"large\" | \"normal\" | \"small\"",
                    "references": {
                        "TButtonSize": {
                            "location": "import",
                            "path": "./button-utils",
                            "id": "src/components/dc-ui-button/button-utils.ts::TButtonSize"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Adds a size to the button. Default value is 'normal'."
                },
                "getter": false,
                "setter": false,
                "attribute": "size",
                "reflect": false,
                "defaultValue": "'normal'"
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TButtonType",
                    "resolved": "\"button\" | \"reset\" | \"submit\"",
                    "references": {
                        "TButtonType": {
                            "location": "import",
                            "path": "./button-utils",
                            "id": "src/components/dc-ui-button/button-utils.ts::TButtonType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Adds a type to the button. Default value is 'submit'."
                },
                "getter": false,
                "setter": false,
                "attribute": "type",
                "reflect": false,
                "defaultValue": "'submit'"
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TButtonVariant",
                    "resolved": "\"light\" | \"link\" | \"primary\" | \"secondary\" | \"tertiary\"",
                    "references": {
                        "TButtonVariant": {
                            "location": "import",
                            "path": "./button-utils",
                            "id": "src/components/dc-ui-button/button-utils.ts::TButtonVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Adds a variant to the button. Default value is 'secondary'."
                },
                "getter": false,
                "setter": false,
                "attribute": "variant",
                "reflect": false,
                "defaultValue": "'secondary'"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TIcon",
                    "resolved": "\"dc_2D\" | \"dc_3D\" | \"dc_3D_printer\" | \"dc_3D_v2\" | \"dc_AI\" | \"dc_AR\" | \"dc_ActiveShuttle\" | \"dc_ActiveShuttle_platform-lift\" | \"dc_GoTo\" | \"dc_GoTo_frame\" | \"dc_add\" | \"dc_add_folder\" | \"dc_add_wishlist\" | \"dc_alert-error-filled\" | \"dc_alert-success-filled\" | \"dc_alert\" | \"dc_arrow_down\" | \"dc_arrow_left\" | \"dc_arrow_outward\" | \"dc_arrow_right\" | \"dc_arrow_right_2\" | \"dc_arrow_up\" | \"dc_arrows_vertical\" | \"dc_article\" | \"dc_axis\" | \"dc_backward_left\" | \"dc_backward_left_double\" | \"dc_basic_points\" | \"dc_battery-0\" | \"dc_battery-fail\" | \"dc_battery-loading\" | \"dc_blog_rexr\" | \"dc_book\" | \"dc_bookmark\" | \"dc_box_open\" | \"dc_brush\" | \"dc_bulb\" | \"dc_cad\" | \"dc_calculator\" | \"dc_calendar\" | \"dc_call\" | \"dc_callout_confirmation\" | \"dc_callout_error\" | \"dc_callout_hint\" | \"dc_callout_information\" | \"dc_cart\" | \"dc_certificate\" | \"dc_chart_line\" | \"dc_chat\" | \"dc_checkmark\" | \"dc_checkmark_active\" | \"dc_checkmark_disabled\" | \"dc_checkmark_inactive\" | \"dc_clipboard\" | \"dc_clock\" | \"dc_close\" | \"dc_cloud\" | \"dc_cloud_drive_error\" | \"dc_comment\" | \"dc_compass\" | \"dc_complete\" | \"dc_components\" | \"dc_configuration\" | \"dc_connection_status\" | \"dc_connection_status_2\" | \"dc_connectivity\" | \"dc_copy\" | \"dc_countertarget\" | \"dc_customerservice\" | \"dc_delete\" | \"dc_device\" | \"dc_document\" | \"dc_document_bmp\" | \"dc_document_csv\" | \"dc_document_doc\" | \"dc_document_dwg\" | \"dc_document_dxf\" | \"dc_document_mp4\" | \"dc_document_pdf\" | \"dc_document_plain\" | \"dc_document_png\" | \"dc_document_ppt\" | \"dc_document_sat\" | \"dc_document_selector\" | \"dc_document_step\" | \"dc_document_txt\" | \"dc_document_vrml\" | \"dc_document_xls\" | \"dc_document_xml\" | \"dc_down\" | \"dc_down_double\" | \"dc_download\" | \"dc_duplicate\" | \"dc_edit\" | \"dc_excavator\" | \"dc_expansion_arrows\" | \"dc_export\" | \"dc_eye\" | \"dc_eye_hide\" | \"dc_facebook_b\" | \"dc_faq02\" | \"dc_feedback\" | \"dc_field_service\" | \"dc_film\" | \"dc_filter_01\" | \"dc_filter_02\" | \"dc_flashlight\" | \"dc_folder\" | \"dc_folder_bookmark_empty\" | \"dc_folder_bookmark_full\" | \"dc_folder_document_empty\" | \"dc_folder_document_full\" | \"dc_folder_image_empty\" | \"dc_folder_image_full\" | \"dc_folder_open\" | \"dc_forward_right\" | \"dc_forward_right_double\" | \"dc_fullscreen_exit\" | \"dc_gerat\" | \"dc_github\" | \"dc_globe\" | \"dc_googleplus_b\" | \"dc_grid_view\" | \"dc_half_complete\" | \"dc_history\" | \"dc_home\" | \"dc_i_shipping_stock\" | \"dc_i_si\" | \"dc_i_sum\" | \"dc_imagery\" | \"dc_imprint\" | \"dc_industry_data_set\" | \"dc_info\" | \"dc_instagram_b\" | \"dc_kinematic\" | \"dc_label\" | \"dc_less_minimize\" | \"dc_link\" | \"dc_linkedin_b\" | \"dc_list_mobile\" | \"dc_list_view\" | \"dc_loading\" | \"dc_locator\" | \"dc_locator_spot\" | \"dc_look_closed\" | \"dc_mail\" | \"dc_material_number\" | \"dc_message\" | \"dc_microsoft-teams\" | \"dc_moneybagwithcoin\" | \"dc_motion\" | \"dc_move_left\" | \"dc_move_right\" | \"dc_music\" | \"dc_my-project\" | \"dc_network\" | \"dc_no_preview\" | \"dc_notification-01\" | \"dc_notification-02\" | \"dc_offline\" | \"dc_online\" | \"dc_options\" | \"dc_organize\" | \"dc_overview\" | \"dc_packet_solution\" | \"dc_palette\" | \"dc_paperclip\" | \"dc_paperplane\" | \"dc_parking\" | \"dc_pause\" | \"dc_pin_classic\" | \"dc_play\" | \"dc_plc\" | \"dc_podcast\" | \"dc_podcast_2\" | \"dc_print\" | \"dc_product\" | \"dc_question\" | \"dc_redo\" | \"dc_repairs\" | \"dc_reset\" | \"dc_robot\" | \"dc_rocket\" | \"dc_routing\" | \"dc_rss\" | \"dc_ruler\" | \"dc_save\" | \"dc_save_as\" | \"dc_screenshot\" | \"dc_search\" | \"dc_service\" | \"dc_service_assembly\" | \"dc_service_stock\" | \"dc_settings\" | \"dc_share\" | \"dc_shift_arrows\" | \"dc_sink\" | \"dc_size\" | \"dc_skyscraper\" | \"dc_solution\" | \"dc_sort\" | \"dc_source\" | \"dc_spare_parts\" | \"dc_spreadsheet\" | \"dc_status\" | \"dc_status_error\" | \"dc_status_hint\" | \"dc_status_information\" | \"dc_status_success\" | \"dc_status_warning\" | \"dc_stop\" | \"dc_stop_filled\" | \"dc_structure\" | \"dc_trophy\" | \"dc_twitter-X\" | \"dc_twitter_b\" | \"dc_uncomplete\" | \"dc_undo\" | \"dc_up\" | \"dc_up_double\" | \"dc_upload\" | \"dc_user\" | \"dc_video\" | \"dc_view_3d\" | \"dc_view_3d_back\" | \"dc_view_3d_bottom\" | \"dc_view_3d_front\" | \"dc_view_3d_left\" | \"dc_view_3d_right\" | \"dc_view_3d_top\" | \"dc_volume_high\" | \"dc_warning\" | \"dc_wechat_b\" | \"dc_weibo_b\" | \"dc_whatsapp_b\" | \"dc_whistle\" | \"dc_wiki_page\" | \"dc_wireless_safety\" | \"dc_wishlist\" | \"dc_wlan\" | \"dc_xing_b\" | \"dc_youtube_b\" | \"dc_zip\" | \"dc_zoom_in\" | \"dc_zoom_out\"",
                    "references": {
                        "TIcon": {
                            "location": "import",
                            "path": "../../svg/icons",
                            "id": "src/svg/icons.ts::TIcon"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Adds an icon to the button. Default value is an empty string."
                },
                "getter": false,
                "setter": false,
                "attribute": "icon",
                "reflect": false
            },
            "iconSource": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Adds custom icon to the button. Using URL"
                },
                "getter": false,
                "setter": false,
                "attribute": "icon-source",
                "reflect": false
            },
            "hideLabel": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Hides the label on the button. Default value is false."
                },
                "getter": false,
                "setter": false,
                "attribute": "hide-label",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the button on the interface. Default value is false."
                },
                "getter": false,
                "setter": false,
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "align": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TButtonAlign",
                    "resolved": "\"center\" | \"left\" | \"right\"",
                    "references": {
                        "TButtonAlign": {
                            "location": "import",
                            "path": "./button-utils",
                            "id": "src/components/dc-ui-button/button-utils.ts::TButtonAlign"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Adds an alignment to the button. Default value is 'center'."
                },
                "getter": false,
                "setter": false,
                "attribute": "align",
                "reflect": false
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "(optional) Adds a name to the button. This is useful for form submissions."
                },
                "getter": false,
                "setter": false,
                "attribute": "name",
                "reflect": false
            },
            "aria": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "SelectedAriaAttributes<TButtonAriaAttributes>",
                    "resolved": "string | { 'aria-controls'?: string; 'aria-expanded'?: Booleanish; 'aria-haspopup'?: boolean | \"true\" | \"false\" | \"menu\" | \"listbox\" | \"tree\" | \"grid\" | \"dialog\"; 'aria-label'?: string; 'aria-pressed'?: boolean | \"true\" | \"false\" | \"mixed\"; }",
                    "references": {
                        "SelectedAriaAttributes": {
                            "location": "import",
                            "path": "../../utils",
                            "id": "src/utils/index.ts::SelectedAriaAttributes"
                        },
                        "TButtonAriaAttributes": {
                            "location": "import",
                            "path": "./button-utils",
                            "id": "src/components/dc-ui-button/button-utils.ts::TButtonAriaAttributes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "aria",
                "reflect": false
            }
        };
    }
    static get methods() {
        return {
            "focusElement": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=dc-ui-button.js.map
